import React from 'react'
import {graphql, useStaticQuery} from "gatsby";
import ServicePage from "../../components/service";

export default function RegulatoryApplicationsPage() {
    const {service} = useStaticQuery(graphql`
        query {
          service: servicesJson(key: {eq: "regulatory-applications"}) {
            title
            title_long
            thumbnail {
              path {
                childImageSharp {
                  gatsbyImageData(width: 1024)
                }
              }
            }
            projects {
              title
              client
              location
            }
          }
        }
    `)
    return (
        <ServicePage service={service}>
            <p>
                REC has extensive experience in assisting clients with applications and permitting with the Department of Fisheries and Oceans (DFO), Alberta Environment and Parks (AEP), and Parks Canada.
            </p>
        </ServicePage>
    )
}
